// src/utils/errorHandler.js
import { toast } from 'react-toastify';

/**
 * Maneja errores de forma centralizada, diferenciando entre entornos de desarrollo y producción.
 * En desarrollo, muestra el error técnico en consola y un toast detallado.
 * En producción, solo muestra un toast con un mensaje amigable y genérico.
 * * @param {Error|any} error El objeto Error o la respuesta de error de la API.
 * @param {string} friendlyMessage Mensaje amigable para el usuario (usado en producción y combinado en desarrollo).
 * @param {string} [context] Texto opcional para añadir más contexto al log de consola.
 */
export const handleError = (error, friendlyMessage, context = '') => {
  // Asumimos 'development' si no está definido o es explícito.
  const isDevelopment = import.meta.env.NODE_ENV === 'development';
  let technicalMessage = '';

  // Intenta extraer el mensaje técnico del error
  if (error instanceof Error) {
    technicalMessage = error.message;
  } else if (typeof error === 'string') {
    technicalMessage = error;
  } else if (error && typeof error.message === 'string') {
    technicalMessage = error.message;
  } else {
    technicalMessage = 'Error desconocido. Revisa el objeto Error completo.';
  }

  if (isDevelopment) {
    const fullLog = `[ERROR ${context}] ${friendlyMessage}: ${technicalMessage}`;
    console.error(fullLog, error);
    // En desarrollo: Muestra el detalle técnico en el toast
    toast.error(`${friendlyMessage} (DEV: ${technicalMessage})`);
  } else {
    // En producción: Solo muestra el mensaje amigable
    toast.error(friendlyMessage);
  }
};